// extracted by mini-css-extract-plugin
export var skipLink = "gv_x0";